module.exports = __webpack_public_path__ + "img/v4_brokerList.54bbf63a.png";